import { useEffect, useState } from 'react'
import { Button, Col, Pagination, Spinner, Table } from 'react-bootstrap'
import { Title } from '../../../../Templates/Title'
import { humanizeDate } from '../../../../Utils/Dates/Dates'
import Swal from 'sweetalert2'
import { getPlayers } from '../../../API/Players/Players'
import { GetPlayersProps, Player } from '../../../API/Players/models'
import { BsPersonWorkspace } from 'react-icons/bs'



export interface HistoryFiltersForm {
    targetName: string;
    startDate: string;
    endDate: string;
    creatorName: string;
}
const defaultPageSize = 30

export const Players = () => {
    const today = new Date().toISOString().split('T')[0]
    const twoMonthsAgo = new Date(new Date().setMonth(new Date().getMonth() - 2)).toISOString().split('T')[0]

    const defaultFilters: GetPlayersProps = {
        page: 1,
        pageSize: 30,
        startDate: twoMonthsAgo,
        endDate: today,
        createdInPromo: false
    }

    const [loading, setLoading] = useState(false)
    const [players, setPlayers] = useState<Player[]>([])
    // const [allCreatorsNames, setAllCreatorNames] = useState<string[]>([])



    // Pagination
    const [totalPages, setTotalPages] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)

    // Filters
    const [filters, setFilters] = useState<GetPlayersProps>({
        page: 1,
        pageSize: 30,
        startDate: twoMonthsAgo,
        endDate: today,
        createdInPromo: false
    })

    const fetchPlayers = async ({ page = 1, pageSize = 15, startDate = filters.startDate, endDate = filters.endDate, createdInPromo = false }: GetPlayersProps) => {
        setLoading(true)
        const res = await getPlayers({ page, pageSize, startDate, endDate, createdInPromo })
        if (res) {
            setPlayers(res.data)
            setTotalPages(res.totalPages)
            setCurrentPage(res.currentPage)
        }
        setLoading(false)
    }

    const handleSearch = () => {

        if (filters.startDate > filters.endDate) {
            Swal.fire({
                icon: 'error',
                text: 'La fecha de inicio no puede ser mayor a la fecha de fin'
            })
            return;
        }

        const startDate = new Date(filters.startDate);
        const endDate = new Date(filters.endDate);
        const diffYears = endDate.getFullYear() - startDate.getFullYear();
        const diffMonths = diffYears * 12 + (endDate.getMonth() - startDate.getMonth());
        console.log(diffMonths, 'diffMonths')
        if (diffMonths > 2) {
            Swal.fire({
                icon: 'error',
                text: 'La diferencia entre fecha de inicio y fecha de fin no puede ser mayor a 2 meses'
            })
            return;
        }


        fetchPlayers({ ...filters, page: 1, pageSize: defaultPageSize })
    }



    const cleanFilters = () => {
        setFilters({ ...defaultFilters })
        fetchPlayers({ ...defaultFilters })
    }


    const handlePageChange = (page: number) => {
        setCurrentPage(page)
        fetchPlayers({ ...filters, page, pageSize: defaultPageSize })
    }



    useEffect(() => {
        fetchPlayers({ ...defaultFilters })
        // getAllCreators();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])



    return (
        <div className='pb-5 mt-4'>
            <Title

                title="Jugadores"
                icon={<BsPersonWorkspace size={30} />}
                subtitle="Registro de jugadores"
            />

            <Col md={12} sm={12} className='mx-auto'>

                <div className='mb-3 mt-5'>
                    <div className="d-flex align-items-end justify-content-between flex-wrap gap-3">
                        <div className="d-flex gap-4 align-items-end">
                            <div className='d-flex gap-2'>
                                <div className="d-flex flex-column align-items-start">
                                    <label htmlFor="start" className="text-white mb-1"><small>Fecha inicio</small></label>
                                    <input
                                        value={filters.startDate}
                                        type="date"
                                        id="start"
                                        name="start"
                                        className="form-control text-white"
                                        onChange={(e) => setFilters({ ...filters, startDate: e.target.value })}
                                    />
                                </div>
                                <div className="d-flex flex-column align-items-start">
                                    <label htmlFor="end" className="text-white mb-1"><small>Fecha fin</small></label>
                                    <input
                                        value={filters.endDate}
                                        type="date"
                                        id="end"
                                        name="end"
                                        className="form-control text-white"
                                        onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
                                    />
                                </div>
                            </div>
                            <div className='d-flex align-items-center gap-2'>
                                <div className="d-flex align-items-center gap-2">
                                    <input
                                        type="checkbox"
                                        id="createdInPromo"
                                        checked={filters.createdInPromo}
                                        onChange={(e) => setFilters({ ...filters, createdInPromo: e.target.checked })}
                                    />
                                    <label htmlFor="createdInPromo" className="text-white"><small>Mostrar solo creados en promoción</small></label>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="d-flex gap-2 align-items-end justify-content-end">
                                <Button
                                    variant='primary'
                                    onClick={handleSearch}
                                    className='text-nowrap'
                                >
                                    Buscar
                                </Button>
                                <Button
                                    variant='secondary'
                                    onClick={cleanFilters}
                                    className='text-nowrap'
                                >
                                    Limpiar filtros
                                </Button>
                            </div>

                        </div>
                    </div>
                </div>

                <div>
                    {loading &&
                        <div className='d-flex justify-content-center align-items-center flex-column text-primaryy' style={{ height: '20vh' }}>
                            <div className="mb-1">
                                Cargando página {currentPage}
                            </div>
                            <Spinner animation="border" variant="primary" />
                        </div>
                    }
                    {!loading && <div>
                        <Table striped bordered hover responsive>
                            <thead>
                                <tr>
                                    <th className='text-sm text-primary text-center'>Fecha</th>
                                    <th className='text-sm text-primary text-center'>Usuario</th>
                                    <th className='text-sm text-primary text-center'>Nombre</th>
                                    <th className='text-sm text-primary text-center'>Email</th>
                                    <th className='text-sm text-primary text-center'>Teléfono</th>

                                </tr>
                            </thead>
                            <tbody>
                                {players.map((row) => (
                                    <tr key={row.id}>
                                        <td className='text-sm text-secondary text-center'>{humanizeDate(row.createdAt)}</td>
                                        <td className='text-sm text-primary text-center'>{row.platformUser}</td>
                                        <td className='text-sm text-primary text-center'>{row.firstName} {row.lastName}</td>
                                        <td className='text-sm text-secondary text-center'>{row.email}</td>
                                        <td className='text-sm text-secondary text-center'>{row.phone}</td>
                                    </tr>

                                ))}
                            </tbody>
                        </Table>
                        <div className='d-flex justify-content-center'>
                            <Pagination>
                                <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
                                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />
                                {currentPage > 3 && (
                                    <>
                                        <Pagination.Item onClick={() => handlePageChange(1)}>1</Pagination.Item>
                                        <Pagination.Ellipsis disabled />
                                    </>
                                )}
                                {[...Array(totalPages)].slice(
                                    Math.max(0, currentPage - 3),
                                    Math.min(totalPages, currentPage + 2)
                                ).map((_, index) => {
                                    const pageNumber = Math.max(1, currentPage - 2) + index;
                                    return (
                                        <Pagination.Item
                                            key={pageNumber}
                                            active={currentPage === pageNumber}
                                            onClick={() => handlePageChange(pageNumber)}
                                        >
                                            {pageNumber}
                                        </Pagination.Item>
                                    );
                                })}
                                {currentPage < totalPages - 2 && (
                                    <>
                                        <Pagination.Ellipsis disabled />
                                        <Pagination.Item onClick={() => handlePageChange(totalPages)}>{totalPages}</Pagination.Item>
                                    </>
                                )}
                                <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
                                <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
                            </Pagination>
                        </div>
                    </div>}
                </div>
            </Col>
        </div >

    )
}
